import React from "react";

import { ViewEditActivity } from "app/userManagement/modules/generic/index";

const ProviderViewEditActivity = () => {
  return (
    <>
      <ViewEditActivity />
    </>
  );
};

export default ProviderViewEditActivity;
